import { SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class LoadingSheetDto{
    @ApiProperty()
    loadingSheetId: number;
    @ApiProperty()
    lotNumber:number;
    @ApiProperty()
    loadingSheetNumber: number;
    @ApiProperty()
    variety: number;
    @ApiProperty()
    grade: string;
    @ApiProperty()
    count: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    createdUser?: string | null;
    @ApiProperty()
    updatedUser?: string | null;
}